import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

export default function useEnvironment(texture, color) {
  const scene = useThree(({ scene }) => scene);
  
  useEffect(() => {
    if (!texture) return;
    
    const oldenv = scene.environment;
    scene.environment = texture;
    
    return () => {
      scene.environment = oldenv;
    };
  }, [scene, texture]);
  
  useEffect(() => {
    if (!color) return;
    
    const oldcolor = scene.background;
    scene.background = color;
    
    return () => {
      scene.background = oldcolor;
    };
  }, [color]);

  return texture;
};